//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/loginPage/main/lan/en';
import createEditTemplate from 'Modules/loginPage/main/.components/createEditTemplate/lan/en';
import uploadImage from 'Modules/loginPage/main/.components/uploadImage/lan/en';

locales = {
    ...locales,
    ...main,
    ...createEditTemplate,
    ...uploadImage,
};

export default locales;